export interface Article {
  id: string;
  slug: string;
  i18nTitle: string;
  i18nDesc: string;
  readTime: number;
  date: string;
  image: string;
  tag: string;
}

export const articles: Article[] = [
  {
    id: 'complete-guide',
    slug: 'allchinabuy-spreadsheet-complete-guide',
    i18nTitle: 'article.complete_guide',
    i18nDesc: 'article.complete_guide_desc',
    readTime: 12,
    date: '2026-08-20',
    image: 'https://readdy.ai/api/search-image?query=A%20large%20wall%20monitor%20displaying%20a%20colorful%20spreadsheet%20of%20product%20listings%20beside%20a%20tidy%20desk%20with%20folded%20fashion%20items%20and%20a%20warm%20ceramic%20mug%2C%20soft%20morning%20light%20through%20a%20loft%20window%2C%20modern%20workspace%20photography%20in%20warm%20cream%20and%20wood%20tones&width=600&height=400&seq=article-complete-2026-01&orientation=landscape&nocache=true',
    tag: 'Guide',
  },
  {
    id: 'is-legit',
    slug: 'is-allchinabuy-legit',
    i18nTitle: 'article.is_legit',
    i18nDesc: 'article.is_legit_desc',
    readTime: 8,
    date: '2026-08-18',
    image: 'https://readdy.ai/api/search-image?query=A%20hand%20holding%20a%20smartphone%20with%20a%20checkmark%20shield%20illustration%20on%20screen%20over%20a%20blurred%20cafe%20background%2C%20online%20safety%20and%20trust%20concept%2C%20warm%20daylight%20with%20soft%20bokeh%2C%20editorial%20photography%20in%20neutral%20beige%20and%20white%20tones&width=600&height=400&seq=article-legit-2026-01&orientation=landscape&nocache=true',
    tag: 'Safety',
  },
  {
    id: 'shipping',
    slug: 'allchinabuy-shipping-cost-guide',
    i18nTitle: 'article.shipping',
    i18nDesc: 'article.shipping_desc',
    readTime: 10,
    date: '2026-08-15',
    image: 'https://readdy.ai/api/search-image?query=A%20cardboard%20parcel%20with%20a%20shipping%20label%20and%20measuring%20tape%20on%20a%20warehouse%20table%20with%20a%20global%20map%20softly%20blurred%20in%20the%20background%2C%20international%20delivery%20concept%2C%20cool%20blue%20and%20neutral%20tones%20with%20soft%20industrial%20lighting%2C%20minimal%20logistics%20photography&width=600&height=400&seq=article-shipping-2026-01&orientation=landscape&nocache=true',
    tag: 'Shipping',
  },
  {
    id: 'coupon',
    slug: 'allchinabuy-coupon-guide',
    i18nTitle: 'article.coupon',
    i18nDesc: 'article.coupon_desc',
    readTime: 6,
    date: '2026-08-12',
    image: 'https://readdy.ai/api/search-image?query=A%20scattered%20arrangement%20of%20golden%20discount%20voucher%20tickets%20and%20a%20red%20scissors%20on%20a%20warm%20terracotta%20tablecloth%2C%20savings%20and%20promotion%20concept%2C%20rich%20warm%20lighting%20with%20soft%20shadows%2C%20minimal%20still%20life%20photography&width=600&height=400&seq=article-coupon-2026-01&orientation=landscape&nocache=true',
    tag: 'Savings',
  },
  {
    id: 'review',
    slug: 'allchinabuy-review',
    i18nTitle: 'article.review',
    i18nDesc: 'article.review_desc',
    readTime: 9,
    date: '2026-08-10',
    image: 'https://readdy.ai/api/search-image?query=A%20person%20comparing%20two%20product%20boxes%20on%20a%20tablet%20at%20a%20bright%20minimal%20desk%20with%20a%20green%20plant%2C%20product%20review%20and%20comparison%20concept%2C%20fresh%20daylight%20with%20clean%20white%20and%20sage%20green%20accents%2C%20editorial%20photography&width=600&height=400&seq=article-review-2026-01&orientation=landscape&nocache=true',
    tag: 'Review',
  },
  {
    id: 'qc',
    slug: 'allchinabuy-qc-guide',
    i18nTitle: 'article.qc',
    i18nDesc: 'article.qc_desc',
    readTime: 7,
    date: '2026-08-08',
    image: 'https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20hovering%20over%20a%20detailed%20stitching%20seam%20of%20a%20denim%20garment%20on%20a%20light%20workbench%2C%20quality%20control%20inspection%20concept%2C%20crisp%20focused%20macro%20detail%20with%20soft%20cool%20lighting%2C%20minimal%20industrial%20photography&width=600&height=400&seq=article-qc-2026-01&orientation=landscape&nocache=true',
    tag: 'QC',
  },
  {
    id: 'how-to-use',
    slug: 'how-to-use-allchinabuy-spreadsheet',
    i18nTitle: 'article.how_to_use',
    i18nDesc: 'article.how_to_use_desc',
    readTime: 9,
    date: '2026-08-22',
    image: 'https://readdy.ai/api/search-image?query=Hands%20navigating%20a%20tablet%20with%20a%20sortable%20product%20list%20while%20a%20laptop%20and%20notebook%20sit%20on%20a%20minimal%20oak%20desk%20in%20soft%20morning%20light%2C%20step%20by%20step%20tutorial%20concept%2C%20warm%20neutral%20palette%20with%20clean%20workspace%20styling%2C%20editorial%20photography&width=600&height=400&seq=article-howto-2026-01&orientation=landscape',
    tag: 'Guide',
  },
  {
    id: 'seller-guide',
    slug: 'allchinabuy-seller-guide',
    i18nTitle: 'article.seller_guide',
    i18nDesc: 'article.seller_guide_desc',
    readTime: 10,
    date: '2026-08-21',
    image: 'https://readdy.ai/api/search-image?query=A%20storefront%20with%20a%20seller%20rating%20display%20of%20five%20golden%20stars%20and%20a%20silhouette%20of%20a%20shopkeeper%20in%20the%20soft%20background%2C%20trusted%20seller%20concept%2C%20warm%20inviting%20retail%20lighting%2C%20minimal%20commercial%20photography&width=600&height=400&seq=article-seller-2026-01&orientation=landscape',
    tag: 'Sellers',
  },
  {
    id: 'beginner-guide',
    slug: 'allchinabuy-beginner-guide',
    i18nTitle: 'article.beginner_guide',
    i18nDesc: 'article.beginner_guide_desc',
    readTime: 11,
    date: '2026-08-19',
    image: 'https://readdy.ai/api/search-image?query=A%20fresh%20startup%20flat%20lay%20with%20a%20smartphone%20shopping%20cart%20icon%20a%20coffee%20cup%20and%20colorful%20sticky%20notes%20on%20a%20clean%20white%20desk%2C%20first%20time%20buyer%20concept%2C%20bright%20optimistic%20daylight%20with%20playful%20pastel%20accents%2C%20minimal%20photography&width=600&height=400&seq=article-beginner-2026-01&orientation=landscape',
    tag: 'Beginner',
  },
  {
    id: 'best-finds',
    slug: 'best-allchinabuy-finds',
    i18nTitle: 'article.best_finds',
    i18nDesc: 'article.best_finds_desc',
    readTime: 8,
    date: '2026-08-17',
    image: 'https://readdy.ai/api/search-image?query=A%20treasure%20hunt%20flat%20lay%20of%20trendy%20sneakers%20sunglasses%20and%20a%20cap%20arranged%20around%20a%20glowing%20spotlight%20on%20a%20dark%20slate%20surface%2C%20best%20finds%20discovery%20concept%2C%20dramatic%20focused%20lighting%20with%20vibrant%20product%20colors%2C%20minimal%20photography&width=600&height=400&seq=article-finds-2026-01&orientation=landscape',
    tag: 'Finds',
  },
  {
    id: 'warehouse-guide',
    slug: 'allchinabuy-warehouse-guide',
    i18nTitle: 'article.warehouse',
    i18nDesc: 'article.warehouse_desc',
    readTime: 9,
    date: '2026-08-16',
    image: 'https://readdy.ai/api/search-image?query=Rows%20of%20labeled%20cardboard%20boxes%20on%20steel%20warehouse%20shelving%20with%20a%20worker%20scanning%20a%20barcode%20in%20the%20distance%2C%20storage%20and%20fulfillment%20concept%2C%20cool%20industrial%20lighting%20with%20clean%20organized%20composition%2C%20minimal%20photography&width=600&height=400&seq=article-warehouse-2026-01&orientation=landscape',
    tag: 'Warehouse',
  },
  {
    id: 'alternatives',
    slug: 'allchinabuy-alternatives',
    i18nTitle: 'article.alternatives',
    i18nDesc: 'article.alternatives_desc',
    readTime: 10,
    date: '2026-08-14',
    image: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20side%20by%20side%20displaying%20different%20shopping%20app%20interfaces%20on%20a%20split%20tone%20background%20of%20teal%20and%20coral%2C%20platform%20comparison%20concept%2C%20modern%20clean%20daylight%20with%20balanced%20composition%2C%20minimal%20photography&width=600&height=400&seq=article-alt-2026-01&orientation=landscape',
    tag: 'Comparison',
  },
  {
    id: 'payment-guide',
    slug: 'allchinabuy-payment-refund-guide',
    i18nTitle: 'article.payment',
    i18nDesc: 'article.payment_desc',
    readTime: 8,
    date: '2026-08-13',
    image: 'https://readdy.ai/api/search-image?query=A%20credit%20card%20and%20smartphone%20payment%20screen%20with%20a%20small%20refund%20arrow%20icon%20on%20a%20minimal%20white%20surface%2C%20secure%20payment%20and%20refund%20concept%2C%20soft%20clean%20lighting%20with%20cool%20green%20accent%20tone%2C%20minimal%20financial%20photography&width=600&height=400&seq=article-payment-2026-01&orientation=landscape',
    tag: 'Payment',
  },
  {
    id: 'tracking-guide',
    slug: 'allchinabuy-tracking-guide',
    i18nTitle: 'article.tracking',
    i18nDesc: 'article.tracking_desc',
    readTime: 7,
    date: '2026-08-11',
    image: 'https://readdy.ai/api/search-image?query=A%20delivery%20package%20with%20a%20tracking%20timeline%20of%20location%20pins%20on%20a%20smartphone%20screen%20over%20a%20blurred%20city%20map%2C%20order%20tracking%20concept%2C%20cool%20blue%20tones%20with%20clean%20digital%20styling%2C%20minimal%20photography&width=600&height=400&seq=article-tracking-2026-01&orientation=landscape',
    tag: 'Tracking',
  },
  {
    id: 'qc-checklist',
    slug: 'allchinabuy-qc-checklist',
    i18nTitle: 'article.qc_checklist',
    i18nDesc: 'article.qc_checklist_desc',
    readTime: 8,
    date: '2026-08-09',
    image: 'https://readdy.ai/api/search-image?query=A%20paper%20checklist%20with%20green%20checkmarks%20and%20a%20pen%20beside%20a%20folded%20garment%20under%20a%20bright%20desk%20lamp%2C%20quality%20checklist%20concept%2C%20crisp%20clean%20lighting%20with%20neutral%20and%20green%20tones%2C%20minimal%20photography&width=600&height=400&seq=article-checklist-2026-01&orientation=landscape',
    tag: 'QC',
  },
  {
    id: 'best-sellers',
    slug: 'best-allchinabuy-sellers',
    i18nTitle: 'article.best_sellers',
    i18nDesc: 'article.best_sellers_desc',
    readTime: 9,
    date: '2026-08-07',
    image: 'https://readdy.ai/api/search-image?query=A%20podium%20of%20three%20golden%20trophy%20cups%20with%20a%20top%20seller%20badge%20floating%20over%20a%20blurred%20marketplace%20stall%2C%20top%20sellers%20award%20concept%2C%20warm%20celebratory%20lighting%20with%20rich%20golden%20tones%2C%20minimal%20photography&width=600&height=400&seq=article-bestsellers-2026-01&orientation=landscape',
    tag: 'Sellers',
  },
];